import Typography from '@Components/typo'
import { PropsWithChildren } from 'react'
import { ClassNameValue } from 'tailwind-merge'
import { cn } from '../../utils/cn'
import { ClassValue } from 'class-variance-authority/types'

interface LinkButtonProps extends PropsWithChildren {
  handleClick: () => void
  className?: ClassValue
  disabled?: boolean
  typoSize?: 'small' | 'base'
}

const LinkButton = ({
  handleClick,
  children,
  className,
  disabled,
  typoSize = 'small',
}: LinkButtonProps) => {
  return (
    <div
      onClick={handleClick}
      className={`${className} ${disabled && 'pointer-events-none'}`}
    >
      <Typography
        size={typoSize}
        className={cn(
          `${
            disabled
              ? 'cursor-not-allowed text-content-disabled'
              : 'cursor-pointer text-link-default hover:underline'
          } `,
          className
        )}
      >
        {children}
      </Typography>
    </div>
  )
}

export default LinkButton
